import AlternatingContent, {
  AlternatingComponentDisplayType
} from './AlternatingComponent'

export default AlternatingContent
export { AlternatingComponentDisplayType }
